/**
 * Api errors reported by the Live-Streaming controller
 */
export var LiveStreamErrorCode;
(function (LiveStreamErrorCode) {
    /**
     * Realtime Recorder for the courtroom cannot be switched mode or started.
     */
    LiveStreamErrorCode["HybridProducerNotReady"] = "live-stream/HybridProducerNotReady";
    /**
     * Unable to find a valid Realtime Recorder for the courtroom.
     */
    LiveStreamErrorCode["NoHybridCapableProducerFoundForLocation"] = "live-stream/NoHybridCapableProducerFoundForLocation";
})(LiveStreamErrorCode || (LiveStreamErrorCode = {}));
